import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import "./UploadVideoSkeleton.scss";

const UploadVideoSkeleton = ({ percent, teamName, date }) => {
  const displayedDate = dayjs(date).format("MMM DD, YYYY");

  return (
    <div className="upload-video-skeleton">
      <div className="upload-video-skeleton__body">
        <span className="upload-video-skeleton__body__percent">{percent}%</span>
        <span className="upload-video-skeleton__body__text">Uploading Video...</span>
      </div>
      <div className="upload-video-skeleton__footer">
        <span className="upload-video-skeleton__footer__team-name">{teamName}</span>
        <span className="upload-video-skeleton__footer__date">{displayedDate}</span>
      </div>
    </div>
  );  
};

UploadVideoSkeleton.propTypes = {
  date: PropTypes.object, 
  percent: PropTypes.number, 
  teamName: PropTypes.string
};

UploadVideoSkeleton.defaultProps = {
  date: new Date(), 
  percent: 0, 
  teamName: ""
}

export default UploadVideoSkeleton;